

import { Box, Typography } from "@mui/material";


const Vcard = ({message}) => {
    let array = message.body.split("\n");
    let numero = "";
    let contact = "";
    for (let index = 0; index < array.length; index++) {
      const v = array[index];
      let values = v.split(":");
      for (let ind = 0; ind < values.length; ind++) {
        if (values[ind].indexOf("+") !== -1) {
          numero = values[ind]
        }
        if (values[ind].indexOf("FN") !== -1) {
          contact = values[ind + 1];
        }
      }
    }

    return (
      <Box>
        <Typography sx={{ mb: 2, fontSize: 10, fontStyle: 'italic' }}>Contato Encaminhado</Typography>
        <Typography>{contact}</Typography>
        <Typography>{numero}</Typography>
      </Box>
    );
  }

  export default Vcard;